(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["po-chat"] && !Shopify.designMode) return;
  try {
    (() => {
  const widget = document.getElementById('po-chat');
  if (!widget) return;
  const es = widget.dataset.locale === 'es';
  const launcher = widget.querySelector('summary');
  const form = widget.querySelector('form');
  const status = widget.querySelector('[data-po-status]');
  const log = widget.querySelector('[data-po-messages]');
  const send = form.querySelector('button[type="submit"]');
  const body = document.getElementById('po-chat-message');
  let token = Array.from(crypto.getRandomValues(new Uint8Array(32)), b => b.toString(16).padStart(2, '0')).join('');
  let invite = new URLSearchParams(location.hash.slice(1)).get('po-invite') || '';
  let started = false, pending = false, receipt = null, lastContent = '';
  if (!invite) { try { const saved = JSON.parse(sessionStorage.getItem('po-chat-session') || 'null'); if (saved && /^[0-9a-f]{64}$/.test(saved.token)) { token = saved.token; started = true; } } catch {} }
  const close = () => { widget.open = false; launcher.focus(); };
  widget.querySelector('[data-po-close]').addEventListener('click', close);
  widget.addEventListener('keydown', e => { if (e.key === 'Escape' && widget.open) { e.preventDefault(); close(); } });
  if (invite) { widget.open = true; history.replaceState(null, '', location.pathname + location.search); }

  async function request(action, extra = {}) {
    const r = await fetch('https://wjgyoitglxirnczcxhew.supabase.co/rest/v1/rpc/website_chat_visitor', {
      method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json', apikey: 'sb_publishable_ao4HUBZgY6tZGaxCMVe0IQ_d3CKHwRd' },
      signal: AbortSignal.timeout(15000),
      body: JSON.stringify({ p_token: token, p_action: action, ...extra })
    });
    if (!r.ok) throw new Error('Chat unavailable');
    return r.json();
  }
  function render(data) {
    const content = JSON.stringify(data.messages);
    if (content === lastContent) return;
    lastContent = content; log.replaceChildren();
    let acknowledged = false;
    for (const message of data.messages) {
      const bubble = document.createElement('div');
      bubble.className = 'po-chat__bubble po-chat__bubble--' + message.author;
      const label = document.createElement('strong');
      label.textContent = message.author === 'studio' ? 'Patricia' : (es ? 'Tú' : 'You');
      const text = document.createElement('p'); text.textContent = message.body;
      const time = document.createElement('time'); time.dateTime = message.created_at;
      time.textContent = new Date(message.created_at).toLocaleTimeString(es ? 'es-ES' : 'en-GB', { hour: '2-digit', minute: '2-digit' });
      bubble.append(label, text, time); log.append(bubble);
      if (!acknowledged && message.author === 'visitor') {
        const acknowledgement = document.createElement('div');
        acknowledgement.className = 'po-chat__bubble po-chat__bubble--automatic';
        const automaticLabel = document.createElement('strong');
        automaticLabel.textContent = es ? 'Respuesta automática' : 'Automatic reply';
        const automaticText = document.createElement('p');
        automaticText.textContent = es ? 'Gracias por tu mensaje. Te responderé por email en cuanto vuelva al estudio.' : 'Thanks for your message. I’ll get back to you by email as soon as I’m back in the studio.';
        acknowledgement.append(automaticLabel, automaticText); log.append(acknowledgement);
        acknowledged = true;
      }
    }
    log.scrollTop = log.scrollHeight;
  }
  form.addEventListener('submit', async e => {
    e.preventDefault(); if (pending || !form.reportValidity() || !body.value.trim()) return;
    pending = true; send.disabled = true;
    const text = body.value.trim();
    if (!receipt || receipt.body !== text) receipt = { body: text, id: crypto.randomUUID() };
    status.textContent = es ? 'Enviando…' : 'Sending…';
    try {
      const data = await request(started ? 'send' : 'start', { p_invite: invite, p_name: document.getElementById('po-chat-name').value.trim() || 'Visitor', p_email: document.getElementById('po-chat-email').value.trim(), p_body: text, p_message_id: receipt.id });
      if (!data.messages.some(m => m.id === receipt.id && m.body === text && m.author === 'visitor')) throw new Error('Not confirmed');
      started = true; invite = ''; try { sessionStorage.setItem('po-chat-session', JSON.stringify({ token })); } catch {} render(data); body.value = ''; receipt = null;
      widget.querySelectorAll('[data-po-identity]').forEach(el => { el.hidden = true; el.querySelectorAll('input').forEach(input => { input.disabled = true; }); });
      status.textContent = es ? 'Mensaje recibido.' : 'Message received.';
    } catch {
      status.textContent = es ? 'Mensaje aún no enviado. Reintenta en un momento o escribe a info@patriciaotero.com.' : 'Message not sent yet. Please retry in a moment. You can also email info@patriciaotero.com.';
    } finally { pending = false; send.disabled = false; }
  });
  async function refresh() {
    if (!started || pending || !widget.open || document.hidden) return;
    pending = true;
    try { render(await request('read')); widget.querySelectorAll('[data-po-identity]').forEach(el => { el.hidden = true; el.querySelectorAll('input').forEach(input => { input.disabled = true; }); }); status.textContent = es ? 'Mensaje recibido.' : 'Message received.'; }
    catch { status.textContent = es ? 'Reconectando… Tu mensaje guardado sigue en Reply Desk.' : 'Reconnecting… Your saved message remains in Reply Desk.'; }
    finally { pending = false; }
  }
  if (started) { widget.querySelectorAll('[data-po-identity]').forEach(el => { el.hidden = true; el.querySelectorAll('input').forEach(input => { input.disabled = true; }); }); refresh(); }
  setInterval(refresh, 5000);
  widget.addEventListener('toggle', refresh);
  document.addEventListener('visibilitychange', refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
